import { BehaviorSubject } from 'rxjs';
let DefaultState = {
	element: null,
	count: 0
}
class CommentsWidgetState extends BehaviorSubject{
	constructor(data=DefaultState){
		super(data);
		this.state = data;
	}
	get element(){
		return this.state.element;
	}
	set element(el){
		if(el!=this.state.el){
			this.state.element = el;
			this.next(this.state);
		}
	}
	get count(){
		return this.state.count;
	}
	set count(count=0){
		if(count!=this.state.count){
			this.state.count = count;
			this.next(this.state);
		}
	}


}

export {CommentsWidgetState}